import { ENDPOINT_URL } from "constants/api-url";
import { OneOnOneNotesResponse } from "responses";
import { PaginationQuery } from "types/feedback-request";
import { http } from "utils";

const CONTROLLER_PREFIX = ENDPOINT_URL.NOTES;

const OneOnOneNotesApi = {
  getNotesForUser: async (
    userId: number,
    query: PaginationQuery,
  ): Promise<OneOnOneNotesResponse[]> => {
    const res = await http.get<OneOnOneNotesResponse[]>(
      `${CONTROLLER_PREFIX}/users/${userId}`,
      { params: query },
    );
    return res.data;
  },
};

export default OneOnOneNotesApi;
